module.exports = __webpack_public_path__ + "static/media/profile-pic.1fefd4af.png";